import { Button } from '@mui/material'
import React from 'react'

const SelectCurrency = ({ loading, selectAction }) => {
  return (
    <div className='currency-select-box'>
      <div className='d-flex justify-content-center align-items-center'>
        <div className='d-flex flex-column'>
          <h5>Select your currency</h5>
          <div className='selector-container'>
            {loading && <div className='loading-context'>
              <div className="spinner-border" role="status" aria-hidden="true"></div>
            </div>}
            <div>
              <div className={loading ? 'disabled selector-div' : 'selector-div'}
                onClick={() => { loading ? console.log() : selectAction("IRR") }}
              >IRR

              </div>
            </div>
            <div>
              <div className={loading ? 'disabled selector-div' : 'selector-div'}
                onClick={() => { loading ? console.log() : selectAction("USD") }}

              >USD

              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  )
}

export default SelectCurrency